import { scan_barcode } from '../../../../../backbone-unorganized/utils/barcodes';
import { WizardStepPage } from '../../WizardStepPage/view';
import { DeviceAddedMessageStepView } from '../DeviceAddedMessageStepView/view';
import { MobileDashboard } from '../../../../../backbone-unorganized/dashboard/views';
import { isWeb } from '../../../../../shared/utils/is';
import { hideLoadingDialog, showLoadingDialog, showErrorMessage } from '../../../../../shared/utils/notifications';
import { ReactPageWrapper } from '../../../../shared/views/ReactPageWrapper';
import { BarcodeScanner } from '@zenput/feature-zencam';

export const MonnitDeviceStepView = WizardStepPage.extend({
    template: '#tpl_monnit_device_step',
    model: null, // Gateway or Sensor
    stepTitleKey: 'mobile_sensors_device_barcode_information',
    success_timeout: 3000, // The length of time (ms) the `device added success` view shows for
    selectedManufacturer: null,

    events: {
        'keyup .barcode_value.id': 'updateDeviceId',
        'keyup .barcode_value.sc': 'updateDeviceSC',
        'click .field_action_btn': 'scanBarcode',
        'click .next_step': 'assignDevice'
    },

    templateHelpers: function () {
        return {
            ...MonnitDeviceStepView.__super__.templateHelpers.apply(this, arguments),
            id_number: this._getDeviceId(),
            sc_number: this._getDeviceSC(),
            id_number_title: _t('mobile_sensors_id_number', { untranslatedID: 'ID' }),
            sc_code_title: _t('mobile_sensors_sc_code', { untranslatedSCCode: 'SC' })
        };
    },

    onRender: function () {
        this.updateNextButtonState(this._isEnabled());
    },

    updateDeviceId: function (event) {
        const target = $(event.target);
        this.model.set_device_id(target.val());
        this.updateNextButtonState(this._isEnabled());
    },

    updateDeviceSC: function (event) {
        const target = $(event.target);
        if (this.isSensorModel()) {
            this.model.set('check_digit', target.val());
        } else {
            this.model.set('secondary_key', target.val());
        }
        this.updateNextButtonState(this._isEnabled());
    },

    scanBarcode: function (event) {
        if (isWeb()) {
            this.openReactBarcodeScanner(event);
        } else {
            this.openBarcodeScanner();
        }
        return false;
    },

    openBarcodeScanner: async function () {
        const scanResult = await scan_barcode();
        if (!scanResult) {
            return false;
        }
        this.model.update_barcode_value(scanResult, this.selectedManufacturer);
        this.render();
        return;
    },

    openReactBarcodeScanner: function (event) {
        const target = event.currentTarget;
        const onScanSuccess = (scanResult) => {
            const barcodes = scanResult.split(':');
            const fieldName = target?.dataset?.fieldName;
            if (fieldName === 'id') {
                this.model.set_device_id(barcodes[0]);
            } else if (fieldName === 'sc') {
                if (this.isSensorModel()) {
                    this.model.set('check_digit', barcodes[1]);
                } else {
                    this.model.set('secondary_key', barcodes[1]);
                }
            } else {
                console.error('Could not set because expected fieldName does not exist.');
            }
            this.render();
        };

        $f.mobile.nav.show_modal(ReactPageWrapper, {
            renderFunction: function () {
                return (
                    <BarcodeScanner
                        onResultCallback={(result) => {
                            if (result != null) {
                                onScanSuccess(result);
                            }
                            this.close();
                        }}
                    />
                );
            }
        });
        return;
    },

    assignDevice: function () {
        const this_ = this;
        showLoadingDialog();
        this.model.set('manufacturer', this.selectedManufacturer);

        var account = $f.mobile.dashboard.get_active_account_or_group();

        this.model.save(
            {},
            {
                type: 'POST',
                success: () => {
                    hideLoadingDialog();
                    $f.mobile.nav.show(DeviceAddedMessageStepView);
                    setTimeout(() => {
                        account.fetch({
                            error: function () {
                                $f.mobile.logging.log_error(
                                    'Error refetching account after sensor device barcode scan',
                                    {
                                        account,
                                        device: this_.model
                                    }
                                );
                            },
                            complete: function () {
                                $f.mobile.nav.go_back_to_view(MobileDashboard, {
                                    active_account_or_group: account,
                                    active_tab_id: 'sensors',
                                    do_not_set_leftnav: true,
                                    reset_active_group_or_account_on_close: false
                                });
                            }
                        });
                    }, this.success_timeout);
                },
                error: (_xhr, res) => {
                    hideLoadingDialog();
                    showErrorMessage($f.mobile.sensors.util.get_error_string_from_response(res, true));
                }
            }
        );
    },

    _isEnabled: function () {
        const deviceId = this.model.get('external_key') || this.model.get('sensor_id');
        const deviceSC = this.model.get('secondary_key') || this.model.get('check_digit');

        return deviceId && deviceSC;
    },

    _getDeviceId: function () {
        if (!this.isSensorModel()) {
            return this.model.get('external_key');
        }

        return this.model.get('sensor_id');
    },

    _getDeviceSC: function () {
        if (!this.isSensorModel()) {
            return this.model.get('secondary_key');
        }

        return this.model.get('check_digit');
    }
});
